import type { PropsWithChildren } from "react";
import { cn } from "@/utils";

export const DescriptionList = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  return <dl className={cn("m-0", className)}>{children}</dl>;
};
